import JobSkills from "./jobSkills";
export default JobSkills;